import { attrConfig as valConfig } from './w-val.js';
import { attrConfig as colorConfig } from './w-color.js';
import { attrConfig as themeColorConfig } from './w-theme-color.js';
import { attrConfig as themeTintConfig } from './w-theme-tint.js';
import { attrConfig as themeShadeConfig } from './w-theme-shade.js';

/** @type {import('@translator').AttrConfig[]} */
export default [valConfig, colorConfig, themeColorConfig, themeTintConfig, themeShadeConfig];
